// Renders the body of a chat message bubble: an image preview or a file download chip,
// plus an optional text caption. Plain-text messages render their text only.

import React from "react";
import { MESSAGE_TYPE, formatBytes } from "./chatMedia";

export default function ChatAttachment({ msg, onImage }) {
  const { message_type: type, body, attachment } = msg;

  if (!type || type === MESSAGE_TYPE.TEXT || !attachment) {
    return <span>{body}</span>;
  }

  return (
    <div>
      {type === MESSAGE_TYPE.IMAGE && (
        <img
          src={attachment.url}
          alt={attachment.name || "image"}
          style={styles.image}
          onClick={() => (onImage ? onImage(attachment.url) : window.open(attachment.url, "_blank"))}
        />
      )}

      {type === MESSAGE_TYPE.FILE && (
        <a href={attachment.url} target="_blank" rel="noreferrer" style={styles.fileChip}>
          <span style={styles.fileIcon}>📎</span>
          <span style={styles.fileMeta}>
            <span style={styles.fileName}>{attachment.name || "Attachment"}</span>
            {attachment.size ? <span style={styles.fileSize}>{formatBytes(attachment.size)}</span> : null}
          </span>
        </a>
      )}

      {body ? <div style={styles.caption}>{body}</div> : null}
    </div>
  );
}

const styles = {
  image: { maxWidth: 200, maxHeight: 200, borderRadius: 8, display: "block", cursor: "pointer", objectFit: "cover" },
  fileChip: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    textDecoration: "none",
    color: "inherit",
    background: "rgba(0,0,0,0.05)",
    borderRadius: 8,
    padding: "6px 10px",
    maxWidth: 220,
  },
  fileIcon: { fontSize: 18 },
  fileMeta: { display: "flex", flexDirection: "column", overflow: "hidden" },
  fileName: { fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  fileSize: { fontSize: 11, opacity: 0.7 },
  caption: { marginTop: 5 },
};
